import React from 'react';


//TODO: not really a factory, but placeholder for refactoring to
//use a factory in the future
const Factory = {
  create(key) {
    switch (key) {
      case 'invoice-1':
        return ({
          title: "Do a Quickie Invoice",
          subtitle: "In this mission you'll do a quick and simple invoice and then send it (to yourself for now).",
          steps: [
            "The Floating Action Button or FAB is for adding stuff",
            "How to add Clients on the fly!",
            "What our Information Panel does, it's pretty cool, if we do say so ourselves",
            "How to send an invoice, just to yourself as a test",
          ],
          estimate: "3 mins"
        });
      case 'website-1':
        return ({
          title: "Wow clients with a Pro Website",
          subtitle: "Here you'll create your own website in about one minute, no seriously. Later on you can add more and play with the design with our themes.",
          steps: [
            "How the website themes work, and are oh so cool ;)",
            "Getting a sneak peek of your website before publishing.",
            "See just how quick you can change and then view this site.",
          ],
          estimate: "1 min"
        });
      case 'setup-1':
        return ({
          title: "Gotta have Clients",
          subtitle: "Here's a simple, dull but oh so important mission… it's an introduction to altering the data behind the scenes (Clients, Crew etc.)",
          steps: [
            "Where to add, edit or delete background data like Clients, Crew etc."
          ],
          estimate: "1 min"
        });
      case 'bid-1':
        return ({
          title: "Get more clients with professional quotes",
          subtitle: "Our bid builder is very flexible to help with nearly any Estimate/Quote aka Bid. Let's learn how simple this can be.",
          steps: [
            "The many ways to customize a Bid",
            "The ability to add Tasks of any kind",
            "Add client on the fly to ease the process",
            "How easy you can get a professional looking print out of the Bid.",
          ],
          estimate: "3 mins"
        });
      case 'timecard-1':
        return ({
          title: "Your time is Money!",
          subtitle: "Here you'll add a simle time record and learn how it can be setup for invoicing later on.",
          steps: [
            "How to add Clients on the fly",
            "Hop popup forms are different than full screen forms",
            "What our Information Panel does, spoiler alert, it contains information.",
            "How to ensure a Time record will be invoiced.",
          ],
          estimate: "2 mins"
        });
      case 'receipt-1':
        return ({
          title: "Get you sshtuff together",
          subtitle: "We'll show you how to add a receipt and you'll realize it'll be much easier on our mobile app!",
          steps: [
            "Adding a Receipt… can Edit it same way as well.",
            "The different types of receipts",
            "How we ensure you don't mess up the data on a form",
          ],
          estimate: "1 min"
        });
      case 'job-1':
        return ({
          title: "Manage a large project",
          subtitle: "Here you'll start a basic job to manage a large project - track multiple tasks, invoices, time and receipts - very good for Maintenance projects.",
          steps: [
            "Add a job",
            "Setup basic information"
          ],
          estimate: "1 min"
        });
      default:
        return ({
          title: "",
          subtitle: "",
          steps: []
        });
    }
  }
}

export default Factory;



// WEBPACK FOOTER //
// ./src/components/admin/Help/Missions/AcceptDialogs/Factory.js